import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AdminData } from '../models/AdminData.model';
import * as globalAdd from '../../../connectionString';
import { SaPaymentModel } from '../models/SaPayment.model';

@Injectable()
export class LicenseDataService {

  constructor(private http: HttpClient) { }

  createPayment(productTransaction, invoiceHtmlContent) {
    return this.http.post(globalAdd.Paneladdress + 'api/SA/SAPaymentManagement/createPayment', { productTransaction: productTransaction, invoiceHtmlContent: invoiceHtmlContent });
  }

  getPaymentsOfHAUser(saId) {
    return this.http.post(globalAdd.Paneladdress + 'api/SA/SAPaymentManagement/getPaymentsOfHAUser', { saId: saId });
  }

  getPendingSalesOfHa(saId) {
    return this.http.get(globalAdd.Paneladdress + 'api/SA/Admin/getPendingSalesOfHa?saId='+saId);
  }

  resendMailToHa(saId, email, name, userName, password, isUsed) {
    return this.http.post(globalAdd.Paneladdress + 'api/SA/Admin/resendMailToHa', { saId: saId,email:email,name:name,userName:userName,password:password, isUsed: isUsed});
    // return this.http.get(globalAdd.Paneladdress + 'api/SA/Admin/resendMailToHa?saId='+saId+'&email='+email+'&name='+name+'&userName='+userName+'&password='+password+'&isUsed='+ isUsed);
  }

  getUserCredentials(saId) {
    return this.http.get(globalAdd.Paneladdress + 'api/SA/Admin/getUserCredentials?saId='+saId);
  }

  paymentCreationSa(data:SaPaymentModel) {
    return this.http.post(globalAdd.Paneladdress + 'api/SA/SAPaymentManagement/paymentCreationSa', data);
  }

  extendDemoLicenseExpiryDate(saId, dateTime) {
    let DemoModel:{saId: string, validTill:Date} = {saId : saId,validTill : dateTime};
    return this.http.post(globalAdd.Paneladdress + 'api/SA/SAPaymentManagement/extendDemoLicenseExpiryDate', DemoModel);
  }

  getProducts() {
    return this.http.get(globalAdd.Paneladdress + 'api/SA/Admin/getProducts');
  }

  getDashData(pageNo: number, searchText: string) {
    return this.http.get(globalAdd.Paneladdress + 'api/SA/Dashboard/dashdata?pageNo='+pageNo+'&text='+searchText);
  }

  getAdmins(pageNo: number, searchText: string, filter) {
    return this.http.get(globalAdd.Paneladdress + 'api/SA/Dashboard/getHaAdmins?pageNo='+pageNo+'&text='+searchText+'&filter='+filter);
  }

  getSingleAdminDetails(saId: string) {
    return this.http.get(globalAdd.Paneladdress + 'api/SA/Dashboard/getSingleHaDetails?saId='+saId);
  }

  getAdminsForLicense() {
    return this.http.get(globalAdd.Paneladdress + 'api/SA/Dashboard/licenseData');
  }

  getAdminUsers(id: string) {
    return this.http.get(globalAdd.Paneladdress + 'api/SA/Dashboard/users?adminId=' + id);
  }

  getUsersWithMemory(id: string) {
    return this.http.get(globalAdd.Paneladdress + 'api/SA/Dashboard/getUsersWithMemory?adminId='+ id);
  }

  checkEmailIsValid(emailText: string, sId: string) {
    // model2: JSON.stringify(data)
    // return this.http.post(globalAdd.Paneladdress + 'api/dashboard/checkEmail', { email: emailText, Id: sId == null ? " " : sId  }, { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) });
    return this.http.get(globalAdd.Paneladdress + 'api/SA/Admin/checkEmail?email='+emailText+'&id='+(sId == null ? " " : sId), { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) });
  }

  generateLicense(data: AdminData) {
    return this.http.post(globalAdd.Paneladdress + 'api/SA/Admin/generatelicense', data );
  }

  deleteHAAdminLicense(id: string) {
    return this.http.post(globalAdd.Paneladdress + 'api/SA/Admin/deleteHaAdminLicense', { saId: id });
  }

  deleteSaHospLicense(id: string) {
    return this.http.post(globalAdd.Paneladdress + 'api/SA/Admin/deleteSaHospLicense', { saHospId: id });
  }

  recoverDeletedSaHospLicense(id: string) {
    return this.http.post(globalAdd.Paneladdress + 'api/SA/Admin/recoverDeletedSaHospLicense', { saHospId: id });
  }

  getQrInfo(id: string) {
    return this.http.get(globalAdd.Paneladdress + 'api/SA/Admin/getQrInfo?saId='+ id);
  }

  getBuildDetailList() {
    return this.http.get(globalAdd.Paneladdress + 'api/Build/getBuildList');
  }

  getBuildHas(id: string) {
    return this.http.post(globalAdd.Paneladdress + 'api/Build/getBuildHas', { buildId: id });
  }

  shareOrRemove(selected, old, buildId) {
    return this.http.post(globalAdd.Paneladdress + 'api/Build/shareOrRemove', { selected: JSON.stringify(selected), old: JSON.stringify(old), buildId: buildId });
  }

  blockActiveAdmin(adminId: string) {
    return this.http.post(globalAdd.Paneladdress + 'api/SA/Admin/blockActiveAdmin', { adminId: adminId });

  }

  blockActiveLicense(saHospId: string) {
    return this.http.post(globalAdd.Paneladdress + 'api/SA/Admin/blockActiveLicense', { saHospId: saHospId });
  }

  getUserLogs(saId: string) {
    return this.http.get(globalAdd.Paneladdress + 'api/SA/ActionHistory/getUserLogs?saId='+ saId );
  }

  getSaParentPaymentModal(saId) {
    return this.http.get(globalAdd.Paneladdress + 'api/SA/Admin/getSaParentPaymentModal?saId='+saId );
  }

  getAllInvoicesDetailsOfHa(saId) {
    return this.http.get(globalAdd.Paneladdress + 'api/SA/Admin/getAllInvoicesDetailsOfHa?saId='+saId);
  }

  getSingleInvoiceInHtml(invoiceNo, saId) {
    return this.http.get(globalAdd.Paneladdress + 'api/SA/Admin/getSingleInvoiceinHtml?invoiceNo='+invoiceNo+'&saId='+saId  );
  }

  getProductsToUpgradeOrDowngrade(saId) {
    return this.http.get(globalAdd.Paneladdress + 'api/SA/Admin/getProductsToUpgradeOrDowngrade?saId='+ saId);
  }

  upgradeOrDowngradeProduct(saId, productId) {
    return this.http.post(globalAdd.Paneladdress + 'api/SA/Admin/upgradeOrDowngradeProduct', { saId: saId, productId: productId });
  }

  getLicenseRequest(hosId) {
    return this.http.get(globalAdd.Paneladdress + 'api/SA/SAPaymentManagement/GetLicenseRequest?HospitalId='+hosId);
  }

  extendLicenseRequest(licenseModel) {
    return this.http.post(globalAdd.Paneladdress + 'api/SA/SAPaymentManagement/ExtendLicenseRequest', licenseModel);
  }

  getValidityRequest(hosId) {
    return this.http.get(globalAdd.Paneladdress + 'api/SA/SAPaymentManagement/GetValidityRequest?HospitalId='+hosId);
  }

  extendValidityRequest(validityModel) {
    return this.http.post(globalAdd.Paneladdress + 'api/SA/SAPaymentManagement/ExtendValidityRequest', validityModel);

  }

  getPendingPayments(hosId) {

    return this.http.get(globalAdd.Paneladdress + 'api/SA/SAPaymentManagement/PendingPayments?HospitalId='+hosId);

  }

  doMasterPayment(masterModel) {
    return this.http.post(globalAdd.Paneladdress + 'api/SA/SAPaymentManagement/MasterPayment', masterModel);

  }

  getDemoLicenseDetails(hosId) {
    return this.http.get(globalAdd.Paneladdress + 'api/SA/SAPaymentManagement/GetUpgradeRequest?HospitalId='+hosId);

  }

  getRegisteredLicense(upgradeModel) {
    return this.http.post(globalAdd.Paneladdress + 'api/SA/SAPaymentManagement/PostUpgradeRequest', upgradeModel);

  }

}
